export function getWindowScrollTop() {
	const root =
		document.documentElement || document.body.parentNode || document.body;
	return window.pageYOffset !== undefined
		? window.pageYOffset
		: (root as HTMLElement).scrollTop;
}
